import { render, staticRenderFns } from "./BaseTableResult.vue?vue&type=template&id=8d94cb46&scoped=true&"
import script from "./BaseTableResult.vue?vue&type=script&lang=js&"
export * from "./BaseTableResult.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableResult.vue?vue&type=style&index=0&id=8d94cb46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d94cb46",
  null
  
)

export default component.exports